import { createBrowserRouter } from "react-router-dom";

import {
  AdminNavbar,
  AdminLogin,
  ForgetPageLink,
  ForgetPassword,
} from "../Components/admin/index";

//admin
import {
  EditRoles,
  CreateDepartment,
  EditViewEmp,
  CreateEmployee,
  CreateRoles,
  AdminDashboard,
  BillFiles,
  FundAllotment,
  AdminPassKeys,
  Authorization,
  Report,
  UploadBill,
  VendorList,
  Budget,
  Banks,
  BillApprovals,
  VendorBills,
  LogReports,
  BudgetEstimation,
  BudgetHeadCreation,
  ReleasefromFinance,
  DemandApproval,
  DemandGeneration,
  CreateProject,
  CreateWorkOrder,
  CreateContractor,
  ProjectDashboard,
  ProjectList,
  ContractorList,
  BudgetHeadList,
  BudgetEstimationList,
  WorkOrderList,
  AddExpense,
  Requisitions,
  ExpenseList,
  CashBook,
  RequisitionsList,
  ECSResponseFiles,
  CreateProposal,
  TechnicalSanction,
  TechnicalSanctionInwards,
  TechnicalSanctionApprove,
  AdministrativeApprovalCreation,
  GRApprovals,
  ProposalList,
  PrograseReport,
  PrograseList,
  CreateOutwards,
  AdministrativeApprovalInwards,
  AdminstrativeApproval,
  ProposalInwardList,
  ProposalApproval,
  GRDraftList,
  WorkOrderInwardList,
  DemandRequest,
  DemandRequestInwardList,
  BudgetEstimationInwardList,
  GrOutwards,
  TechnicalSanctionOutwards,
  WorkOrderOutwards,
  EditWorkOrderList,
  EditWorkOrder,
  SchemeCreation,
  ReleasefromFinanceForm,
  FinancialGR,
  ProgressReportInwardsList,
  Dashboardmain,
  ViewDemandGeneration,
  Mapfunction,
  ShowMapProposal,
  ShowMapTechnical,
  MapfunctionForTechnicalSanction,
  ShowMapProgressReport,
  DemandRequestOutwards,
  AdministrativeOutwards,
  LimitOutward,
  CreateProposalStatewise,
  ProposalInwardStateWise,
  EditProposal,
  ECSReport,
  ECSUpdate,
  ReleasefromFinanceWorkForm,
  UpdateGRDraft,
  EditProject,
  GRProposalCreation,
  FundReleaseFromBDS,
  TrackBill,
  ECSTransferFiles,
  OldBillUpload,
  OldDemandApproval,
  ViewOldBills,
  EditDemandGeneration,
  RejectedWorksTracker, Homepage
} from "../Components/admin/pages/index";
import Taxes from "../Components/admin/pages/Master/Taxes/Taxes";
import VendorRegister from "../Components/admin/pages/Vendor Management/VendorRegister/VendorRegister";
import { Rates, Ulb } from "../Components/admin/pages/Master";
import {
  AddProduct,
  BinManagement,
  GRN,
  PurchaseList,
} from "../Components/admin/pages/Inventory Management";
import {
  BudgetEstimationReport,
  BudgetHeadReport,
  GrReport,
  ProjectReport,
  ProposalReport,
  ReleasefromfinanceReport,
  VendorReport,
  WorkOrderReport,
} from "../Components/admin/pages/Report";
// import {  } from "../Components/admin/pages/BudgetManagement";
import { ExpenditureDetails } from "../Components/admin/pages/Expenditure Details";
import { GRPendingList } from "../Components/admin/pages/Technical Sanction";
import { ProposalReportManagement } from "../Components/admin/pages/ProposalReportManagement";
import { WorkStatusReport } from "../Components/admin/pages/WorkStatusReport";
import GRSanctionWork from "../Components/admin/pages/GRSanctionWork/GRSanctionWorks";
import SantionWorkList from "../Components/admin/pages/GRSanctionWork/SantionWorkList/SantionWorkList";
import PrivacyPolicypage from "../Components/Users/PrivacyPolicy/PrivacyPolicy";
import {
  CreateTicket,
  ViewChat,
  ViewTicket,
  ViewTicketForAdmin,
  ViewChatForAdmin,
  ClosedTickets,
  GrievanceDashboard,
  HOTickets,
} from "../Components/admin/pages/Grievance";
import ProtectedRoute from "./ProtectedRoute";
import ECSGeneration from "../Components/admin/pages/ECSGeneration/ECSGeneration";
import OldECSGeneration from "../Components/admin/pages/ECSGeneration/OldECSGeneration";
import VendorApproval from "../Components/admin/pages/Vendor Management/VendorApproval/VendorApproval";
import VendorExcelUpload from "../Components/admin/pages/Uploadexcel/VendorExcelUpload";
import OldWorkOrderUpload from "../Components/admin/pages/Uploadexcel/oldworkorders";
// let token = localStorage.getItem("Usertoken");
import UploadGRProposalCreation from "../Components/admin/pages/GRProposalCreation/ProposalGRCreation/UploadGRProposalCreation";


const router = createBrowserRouter([
  // {
  //   path: "/",
  //   element: <AdminLogin />,
  // },
  {
    path: "/",
    element: <Homepage />
  },
  {
    path: "/AdminLogin",
    element: <AdminLogin />,
  },
  {
    path: "/ForgetPassword",
    element: <ForgetPassword />,
  },
  {
    path: "/ForgetPageLink/:Link",
    element: <ForgetPageLink />,
  },
  {
    path: "/AdminDashboard",
    element: <AdminNavbar />,
    children: [
      {
        path: "",
        element: <AdminDashboard />,
      },
      {
        path: "Authorization",
        element: <Authorization />,
      },

      {
        path: "EditRoles",
        element: <EditRoles />,
      },
      {
        path: "CreateDepartment",
        element: <CreateDepartment />,
      },
      {
        path: "CreateEmployee",
        element: <CreateEmployee />,
      },
      {
        path: "EditViewEmp",
        element: <EditViewEmp />,
      },
      {
        path: "CreateRoles",
        element: <CreateRoles />,
      },
      {
        path: "BillFiles",
        element: <BillFiles />,
      },
      {
        path: "FundAllotment",
        element: <FundAllotment />,
      },
      {
        path: "AdminPassKeys",
        element: <AdminPassKeys />,
      },
      {
        path: "Report",
        element: <Report />,
      },
      {
        path: "ProjectReport",
        element: <ProjectReport />,
      },
      {
        path: "BudgetHeadReport",
        element: <BudgetHeadReport />,
      },
      {
        path: "BudgetEstimationReport",
        element: <BudgetEstimationReport />,
      },
      {
        path: "WorkOrderReport",
        element: <WorkOrderReport />,
      },
      {
        path: "VendorReport",
        element: <VendorReport />,
      },
      {
        path: "ReleasefromfinanceReport",
        element: <ReleasefromfinanceReport />,
      },
      {
        path: "UploadBill",
        element: <UploadBill />,
      },
      {
        path: "VendorList",
        element: <VendorList />,
      },
      {
        path: "Budget",
        element: <Budget />,
      },
      {
        path: "Banks",
        element: <Banks />,
      },
      {
        path: "Rates",
        element: <Rates />,
      },
      {
        path: "BillApprovals",
        element: <BillApprovals />,
      },
      {
        path: "VendorBills",
        element: <VendorBills />,
      },
      {
        path: "Taxes",
        element: <Taxes />,
      },
      {
        path: "VendorRegister",
        element: <VendorRegister />,
      },
      {
        path: "LogReports",
        element: <LogReports />,
      },
      {
        path: "AddProduct",
        element: <AddProduct />,
      },
      {
        path: "PurchaseList",
        element: <PurchaseList />,
      },
      {
        path: "BudgetEstimation",
        element: <BudgetEstimation />,
      },
      {
        path: "BudgetHeadCreation",
        element: <BudgetHeadCreation />,
      },
      {
        path: "ReleasefromFinance",
        element: <ReleasefromFinance />,
      },
      {
        path: "DemandApproval",
        element: <DemandApproval />,
      },
      {
        path: "DemandGeneration",
        element: <DemandGeneration />,
      },
      {
        path: "DemandRequest",
        element: <DemandRequest />,
      },
      {
        path: "DemandRequestInwardList",
        element: <DemandRequestInwardList />,
      },
      {
        path: "CreateGR",
        element: <CreateProject />,
      },
      {
        path: "CreateProposal",
        element: <CreateProposal />,
      },
      {
        path: "CreateWorkOrder",
        element: <CreateWorkOrder />,
      },
      {
        path: "WorkOrderInwardList",
        element: <WorkOrderInwardList />,
      },
      {
        path: "CreateVendor",
        element: <CreateContractor />,
      },
      {
        path: "ProjectDashboard",
        element: <ProjectDashboard />,
      },
      {
        path: "GRList",
        element: <ProjectList />,
      },
      {
        path: "VendorList",
        element: <ContractorList />,
      },
      {
        path: "BudgetHeadList",
        element: <BudgetHeadList />,
      },
      {
        path: "BudgetEstimationList",
        element: <BudgetEstimationList />,
      },
      {
        path: "WorkOrderList",
        element: <WorkOrderList />,
      },
      // {
      //   path: "ReleaseFromFinanceHead",
      //   element: <ReleaseFromFinanceHead />
      // },
      {
        path: "ExpenditureDetails",
        element: <ExpenditureDetails />,
      },
      {
        path: "AddExpense",
        element: <AddExpense />,
      },
      {
        path: "Requisitions",
        element: <Requisitions />,
      },
      {
        path: "ExpenseList",
        element: <ExpenseList />,
      },
      {
        path: "GRN",
        element: <GRN />,
      },
      {
        path: "BinManagement",
        element: <BinManagement />,
      },
      {
        path: "CashBook",
        element: <CashBook />,
      },
      {
        path: "RequisitionsList",
        element: <RequisitionsList />,
      },
      {
        path: "ECSResponseFiles",
        element: <ECSResponseFiles />,
      },
      {
        path: "TechnicalSanction/:id",
        element: <TechnicalSanction />,
      },
      {
        path: "TechnicalSanctionInwards",
        element: <TechnicalSanctionInwards />,
      },
      {
        path: "GRPendingList",
        element: <GRPendingList />,
      },
      {
        path: "GRDraftList",
        element: <GRDraftList />,
      },
      {
        path: "TechnicalSanctionApprove/:id",
        element: <TechnicalSanctionApprove />,
      },
      {
        path: "Ulb",
        element: <Ulb />,
      },
      {
        path: "AdministrativeApprovalCreation",
        element: <AdministrativeApprovalCreation />,
      },
      {
        path: "AdministrativeApprovalInwards",
        element: <AdministrativeApprovalInwards />,
      },
      {
        path: "AdminstrativeApproval/:id",
        element: <AdminstrativeApproval />,
      },
      {
        path: "GRApprovals",
        element: <GRApprovals />,
      },
      {
        path: "GrReport",
        element: <GrReport />,
      },
      {
        path: "ProposalList",
        element: <ProposalList />,
      },
      {
        path: "ProposalInwardsList",
        element: <ProposalInwardList />,
      },
      {
        path: "ProposalApprove/:id",
        element: <ProposalApproval />,
      },
      {
        path: "ProposalReport",
        element: <ProposalReport />,
      },
      {
        path: "ProgressReport",
        element: <PrograseReport />,
      },
      {
        path: "BudgetEstimationInwardList",
        element: <BudgetEstimationInwardList />,
      },
      {
        path: "ProgressList",
        element: <PrograseList />,
      },
      {
        path: "CreateOutwards",
        element: <CreateOutwards />,
      },
      {
        path: "GrOutwards",
        element: <GrOutwards />,
      },
      {
        path: "TechnicalSanctionOutwards",
        element: <TechnicalSanctionOutwards />,
      },
      {
        path: "WorkOrderOutwards",
        element: <WorkOrderOutwards />,
      },
      {
        path: "EditWorkOrderList",
        element: <EditWorkOrderList />,
      },
      {
        path: "EditWorkOrder/:id",
        element: <EditWorkOrder />,
      },
      {
        path: "SchemeCreation",
        element: <SchemeCreation />,
      },
      {
        path: "ReleasefromFinanceForm",
        element: <ReleasefromFinanceForm />,
      },
      {
        path: "FinancialGR",
        element: <FinancialGR />,
      },
      {
        path: "ProgressReportInwardsList",
        element: <ProgressReportInwardsList />,
      },
      {
        path: "ViewDemandGeneration",
        element: <ViewDemandGeneration />,
      },
      {
        path: "Mapfunction",
        element: <Mapfunction />,
      },
      {
        path: "ShowMapProposal/:id",
        element: <ShowMapProposal />,
      },
      {
        path: "ShowMapTechnical/:id/:technicalID",
        element: <ShowMapTechnical />,
      },
      {
        path: "MapfunctionForTechnicalSanction",
        element: <MapfunctionForTechnicalSanction />,
      },
      {
        path: "Dashboardmain",
        element: <Dashboardmain />,
      },
      {
        path: "ShowMapProgressReport/:id",
        element: <ShowMapProgressReport />,
      },
      {
        path: "AdministrativeOutwards",
        element: <AdministrativeOutwards />,
      },
      {
        path: "LimitOutward",
        element: <LimitOutward />,
      },
      {
        path: "CreateProposalStatewise",
        element: <CreateProposalStatewise />,
      },
      {
        path: "ProposalInwardStateWise",
        element: <ProposalInwardStateWise />,
      },
      {
        path: "EditProposal/:id",
        element: <EditProposal />,
      },
      {
        path: "ECSReport",
        element: <ECSReport />,
      },
      {
        path: "ECSUpdate",
        element: <ECSUpdate />,
      },

      {
        path: "ECSTransferFiles",
        element: <ECSTransferFiles />,
      },
      {
        path: "ReleasefromFinanceWorkForm",
        element: <ReleasefromFinanceWorkForm />,
      },
      {
        path: "UpdateGRDraft",
        element: <UpdateGRDraft />,
      },
      {
        path: "DemandRequestOutwards",
        element: <DemandRequestOutwards />,
      },
      {
        path: "GRProposalCreation",
        element: <GRProposalCreation />,
      },
      {
        path: "ProposalReportManagement",
        element: <ProposalReportManagement />,
      },
      {
        path: "WorkStatusReport",
        element: <WorkStatusReport />,
      },
      {
        path: "GRSanctionWork",
        element: <GRSanctionWork />,
      },
      {
        path: "SantionWorkList/:id",
        element: <SantionWorkList />,
      },
      {
        path: "CreateTicket",
        element: <CreateTicket />,
      },
      {
        path: "ViewTicket",
        element: <ViewTicket />,
      },
      {
        path: "ViewChat/:Ticketid/:Sender",
        element: <ViewChat />,
      },
      {
        path: "ViewTicketForAdmin",
        element: <ViewTicketForAdmin />,
      },
      {
        path: "ViewChatForAdmin/:Ticketid/:Sender",
        element: <ViewChatForAdmin />,
      },
      {
        path: "ClosedTickets",
        element: <ClosedTickets />,
      },
      {
        path: "GrievanceDashboard",
        element: <GrievanceDashboard />,
      },
      {
        path: "HOTickets",
        element: <HOTickets />,
      },
      {
        path: "FundReleaseFromBDS",
        element: <FundReleaseFromBDS />,
      },
      {
        path: "TrackBill",
        element: <TrackBill />,
      },
      {
        path: "ECSGeneration",
        element: <ECSGeneration />,
      },
      {
        path: "vendorApproval",
        element: <VendorApproval />,
      },
      {
        path: "OldBillUpload",
        element: <OldBillUpload />,
      },
      {
        path: "ViewOldBills",
        element: <ViewOldBills />,
      },
      {
        path: "OldDemandApproval",
        element: <OldDemandApproval />,
      },
      {
        path: "OldECSGeneration",
        element: <OldECSGeneration />,
      },
      {
        path: "UploadVendorExcel",
        element: <VendorExcelUpload />,
      },
      {
        path: "UploadWorkOrderExcel",
        element: <OldWorkOrderUpload />,
      },
      {
        path: "EditDemandGeneration/:demandId",
        element: <EditDemandGeneration />,
      },
      {
        path: "RejectedWorksTracker",
        element: <RejectedWorksTracker />,
      },
       {
        path: "UploadGRProposalCreation",
        element: <UploadGRProposalCreation />,
      },
    ],
  },
  {
    path: "/PrivacyPolicy",
    element: <PrivacyPolicypage />,
  },
]);

export default router;
